import { AnyAction } from '@reduxjs/toolkit'
import { all, put, takeLatest } from 'redux-saga/effects'
import { defaultFlow } from 'redux/config/saga/Common'
import { complianceActions } from './complianceActions'
import complianceService from './complianceService'
import { complianceReducers } from './complianceSlice'

export function* getComplianceOverview(action: AnyAction) {
  yield put(complianceReducers.setOverviewLoading())
  yield defaultFlow(
    action,
    complianceService.getComplianceOverview,
    complianceReducers.getComplianceOverviewSuccess
  )
}

export function* getComplianceOverviewFailed() {
  yield put(complianceReducers.getComplianceOverviewFailed())
}

export function* watchGetComplianceOverview() {
  yield takeLatest(
    complianceActions.getComplianceOverview.type,
    getComplianceOverview
  )
}

export function* watchGetComplianceOverviewFailed() {
  yield takeLatest(
    `${complianceActions.getComplianceOverview.type}Failed`,
    getComplianceOverviewFailed
  )
}

export default function* complianceSaga() {
  yield all([watchGetComplianceOverview(), watchGetComplianceOverviewFailed()])
}
